export default "__VITE_ASSET__DaUb3glB__"